import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { PASSWORD_REQUIREMENTS } from '../../utils/passwordPolicy';

// Live checklist shown under a new-password field.
export default function PasswordRequirements({ value }) {
  return (
    <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
      {PASSWORD_REQUIREMENTS.map((r) => {
        const met = r.test(value || '');
        const Icon = met ? CheckCircle2 : Circle;
        return (
          <li key={r.label} className={`flex items-center gap-1.5 text-xs ${met ? 'text-green-600 dark:text-green-400' : 'text-neutral-500'}`}>
            <Icon className="w-3.5 h-3.5 shrink-0" />
            {r.label}
          </li>
        );
      })}
    </ul>
  );
}
